import { Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getDeviceRoute } from "../../common/utilities/RouteHelpers";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { ActionMenuItem } from "./ActionMenuItem";
import useNavigateTo, { NavigateToOptions } from "../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../common/enums/NewViewTypeEnum";

export type ActionMenuProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    actionIcon?: any,
    hideIfEmpty?: boolean,
    actionItems: ActionMenuItem[];
    ariaLabel?: string,
    id?: string,
    useFontSize?: boolean
    toolTip?: string;
};

export default function ActionMenu({ 
    actionIcon,
    hideIfEmpty,
    actionItems,
    ariaLabel,
    id,
    useFontSize = false,
    toolTip
}: ActionMenuProps) {

    const navigateTo = useNavigateTo();
    const routeContext = useRouteContext();
    const [anchorElement, setAnchorElement] = useState<HTMLButtonElement>();
    const open = Boolean(anchorElement);
    const theme = useTheme();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setAnchorElement(event.currentTarget);
    };

    const handleClose = (item: ActionMenuItem, shiftKey: boolean, ctrlKey: boolean) => {
        setAnchorElement(undefined);

        if (item.viewID) {

            let options: NavigateToOptions | undefined;

            if (shiftKey || ctrlKey) {
                options = {
                    newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
                }
            }
    
            const url = getDeviceRoute(item.viewID, routeContext.groupID, routeContext.wellID, routeContext.deviceID);
            navigateTo(url, options);
        }
        else if (item.onClick) {
            item.onClick();
        }
    };

    function renderMoreActionsButton() {
        return (
             <IconButton
                        color="inherit"
                        disabled={(actionItems?.length ?? 0) === 0}
                        aria-label={ariaLabel ?? "actions"}
                        aria-controls={id ?? "action-menu"}
                        aria-haspopup="true"
                        onClick={handleClick}
                            sx={useFontSize
                                ? {
                                    fontSize: "1em",
                                    padding: 0
                                }
                                : undefined
                            }
                    >
                        {actionIcon ? actionIcon : 
                        
                            <MoreVertIcon 
                                fontSize="inherit"
                            />
                        }
                    </IconButton>

        )
    }

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            justifyContent: 'flex-end'
        }}>
            {hideIfEmpty && (actionItems?.length ?? 0) === 0 ?
                null :
                
            <Box>

                {toolTip ?
                <Tooltip title={toolTip} arrow={true}>
                    {renderMoreActionsButton()}
                </Tooltip>
                :

                    renderMoreActionsButton()
                }


                <Menu
                    id={id ?? "action-menu"}
                    color='textPrimary'
                    anchorEl={anchorElement}

                    //getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}

                    keepMounted
                    open={open}
                    //onClose={(ev) => handleClose}>
                    onClick={() => setAnchorElement(undefined)}>
                    {actionItems.map((item, index) => [

                            item.dividerBefore && <Divider key={`db${index}`}/>,
                            <MenuItem
                                key={`mi${index}`}
                                disabled={item.disabled}
                                onClick={(ev) => {handleClose(item, ev.shiftKey, ev.ctrlKey)}}
                            >
                                

                                {item.icon && <ListItemIcon sx={{ minWidth: theme.spacing(4) }}>
                                    {item.checked && item.checkedIcon ? <item.checkedIcon /> : <item.icon />}
                                </ListItemIcon>}

                                <Typography variant='inherit'>
                                    {item.label}
                                </Typography>
                            </MenuItem>,

                            item.dividerAfter && 
                                actionItems.length > 1 && 
                                <Divider key={`da${index}`}/>

                    ])}
                </Menu>
            </Box>
            }
        </Box>
    );
}

